export var IdWebUiDefinitionCategories;
(function (IdWebUiDefinitionCategories) {
    IdWebUiDefinitionCategories[IdWebUiDefinitionCategories["NurseryProducts"] = 16] = "NurseryProducts";
})(IdWebUiDefinitionCategories || (IdWebUiDefinitionCategories = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdWebUiDefinitionCategories.ts
// module id = 1144
// module chunks = 3